import { memo, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { twMerge } from 'tailwind-merge';
import cn from 'classnames';
import { UrlUtils } from 'src/utils';
import { IAppConfig, ICategory } from 'src/services/AppService';
import { categoryConfigSelector, pageSelector } from 'src/selectors/app';
import { Button, Container, Element, Icon, RouterLink } from 'src/components';
import Menu from 'src/components/menu';
import Scrollbars from 'src/components/scrollbar';
import { LocationSelect } from 'src/layout/breadcrumb/location';

interface IProps {
    isExpand: boolean;
    setIsExpand: (isExpand: boolean) => void;
    isSticky: boolean;
    config?: IAppConfig;
}

const categorySoccer: any = {
    name: 'Bóng đá',
    url: '/bong-da.epi',
    childs: [
        // {
        //     name: 'Euro 2024',
        //     url: '/bong-da/euro-giai-dau-150.epi',
        // },
        // {
        //     name: 'Copa America 2024',
        //     url: '/bong-da/copa-america-giai-dau-151.epi',
        // },
    ],
};

function NavbarExpand({ isExpand, setIsExpand, isSticky, config }: IProps) {
    let categories = useSelector(categoryConfigSelector);
    const page = useSelector(pageSelector);
    const isPageContentDetail = UrlUtils.isContentDetailPage(page.type);
    const [showScrollbar, setShowScrollbar] = useState<boolean>(false);

    const onClick = () => {
        setTimeout(() => setIsExpand(false), 100);
    };

    useEffect(() => {
        return () => {
            setIsExpand(false);
            document.body.classList.remove('noscroll');
        };
    }, []);

    useEffect(() => {
        if (isExpand) {
            if ((isPageContentDetail && isSticky) || !isPageContentDetail) {
                document.body.classList.add('noscroll');
            }
        } else {
            document.body.classList.remove('noscroll');
        }
    }, [isExpand, page, isSticky]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setShowScrollbar(true);
        }
    }, []);

    if (config?.categories) {
        categories = config.categories;
    }

    const renderChildCategories = (child: ICategory[] = []) => {
        return child.map((item: ICategory, index: number) => (
            <Menu.List.Item
                key={`child.${index}`}
                className={cn(
                    'child-category',
                    'block',
                    'text-[1.4rem] leading-[25px]',
                    'md:text-[1.6rem] md:w-[33.33%]'
                )}
            >
                <RouterLink
                    className={cn(
                        'block',
                        'h-[32px] leading-[32px]',
                        'pl-[24px]',
                        'md:h-[50px] md:leading-[50px]'
                    )}
                    to={item.url}
                    onClick={onClick}
                    newTab={item.newTab}
                    title={item.name}
                >
                    <Element renderAs="span">{item.name}</Element>
                </RouterLink>
            </Menu.List.Item>
        ));
    };

    const renderCategories = useCallback(() => {
        return categories?.map((item: ICategory, index: number) => {
            return (
                <Menu.List.Item
                    key={`parent.${index}`}
                    className={cn(
                        'parent-category',
                        'relative leading-[26px]',
                        'md:flex md:border-b md:border-solid md:border-[#e9ecef]'
                    )}
                >
                    <RouterLink
                        className={cn(
                            'flex items-center',
                            'h-[40px] leading-[40px]',
                            'max-md:pr-[6px] max-md:pl-[16px]',
                            'max-md:bg-[#e9ecef]',
                            'max-md:border-t max-md:border-solid max-md:border-[#dee2e6]',
                            'md:w-[25%] md:h-[50px] md:pl-[10px] md:leading-[50px] md:font-bold'
                        )}
                        to={item.url}
                        title={item.name}
                        onClick={onClick}
                    >
                        <Element
                            className={'text-[1.6rem] uppercase'}
                            renderAs="span"
                        >
                            {item.name}
                        </Element>
                    </RouterLink>
                    <Menu.List
                        className={cn('md:flex md:flex-wrap md:w-[75%]')}
                    >
                        {renderChildCategories(item.childs)}

                        {/* giao-duc */}
                        {item.id === 59 &&
                            renderChildCategories([
                                {
                                    name: 'Tuyển Sinh 2026',
                                    url: '/tuyen-sinh-tag12842.epi',
                                },
                            ] as any)}
                    </Menu.List>
                </Menu.List.Item>
            );
        });
    }, [categories]);

    const renderMenu = () => {
        return (
            <>
                <Element
                    className={
                        'md:border-b-[10px] md:border-solid md:border-[#e9ecef]'
                    }
                >
                    <Container className="max-xs:p-0">
                        <LocationSelect onClick={onClick} />
                    </Container>
                </Element>
                <Menu.List>
                    <Container className="max-xs:p-0">
                        <Menu.List.Item
                            className={cn(
                                'parent-category',
                                'relative leading-[26px]',
                                'md:flex md:border-b md:border-solid md:border-[#e9ecef]'
                            )}
                        >
                            <RouterLink
                                className={cn(
                                    'flex items-center grow',
                                    'h-[40px] leading-[40px]',
                                    'pr-[6px] pl-[16px]',
                                    'max-md:border-t max-md:border-solid max-md:border-[#dee2e6]',
                                    'md:w-[25%] md:h-[50px] md:pl-[10px] md:leading-[50px] md:font-bold',
                                    'max-md:bg-[#fdf7ea]'
                                )}
                                title="Bóng đá"
                                to="/bong-da.epi"
                            >
                                <Element
                                    className={'text-[1.6rem] uppercase'}
                                    renderAs="span"
                                >
                                    Bóng đá
                                </Element>
                                <Icon
                                    className={cn(
                                        'max-md:w-[28px] max-md:h-[28px]',
                                        'max-md:ml-auto',
                                        'max-md:bg-[url(https://baomoi-static.bmcdn.me/web/styles/img/ic-football.png)]',
                                        'max-md:bg-cover max-md:bg-center max-md:bg-no-repeat'
                                    )}
                                />
                            </RouterLink>
                            <Menu.List
                                className={cn(
                                    'md:flex md:flex-wrap md:w-[75%] max-md:bg-[#fdf9e980]'
                                )}
                            >
                                {renderChildCategories(categorySoccer.childs)}
                            </Menu.List>
                        </Menu.List.Item>
                        <Menu.List.Item
                            className={cn(
                                'parent-category',
                                'relative leading-[26px]',
                                'md:flex md:border-b md:border-solid md:border-[#e9ecef]'
                            )}
                        >
                            <RouterLink
                                className={cn(
                                    'flex items-center grow',
                                    'h-[40px] leading-[40px]',
                                    'pr-[6px] pl-[16px]',
                                    'max-md:border-t max-md:border-solid max-md:border-[#dee2e6]',
                                    'md:w-[25%] md:h-[50px] md:pl-[10px] md:leading-[50px] md:font-bold',
                                    'max-md:bg-[#fdf7ea]'
                                )}
                                to="/tien-ich.epi"
                                title="Tiện ích"
                            >
                                <Element
                                    className={'text-[1.6rem] uppercase'}
                                    renderAs="span"
                                >
                                    Tiện ích
                                </Element>
                                <Icon
                                    className={cn(
                                        'max-md:w-[28px] max-md:h-[28px]',
                                        'max-md:ml-auto',
                                        'max-md:bg-[url(https://baomoi-static.bmcdn.me/web/styles/img/ic-utility.png)]',
                                        'max-md:bg-cover max-md:bg-center max-md:bg-no-repeat'
                                    )}
                                />
                            </RouterLink>
                        </Menu.List.Item>
                        <Menu.List.Item
                            className={cn(
                                'parent-category',
                                'relative leading-[26px]',
                                'md:flex md:border-b md:border-solid md:border-[#e9ecef]'
                            )}
                        >
                            <RouterLink
                                className={cn(
                                    'flex items-center grow',
                                    'h-[40px] leading-[40px]',
                                    'pr-[6px] pl-[16px]',
                                    'max-md:border-t max-md:border-solid max-md:border-[#dee2e6]',
                                    'md:w-[25%] md:h-[50px] md:pl-[10px] md:leading-[50px] md:font-bold',
                                    'max-md:bg-[#fdf7ea]'
                                )}
                                to="/audio.epi"
                                onClick={onClick}
                                title="Audio"
                            >
                                <Element
                                    className={'text-[1.6rem] uppercase'}
                                    renderAs="span"
                                >
                                    Audio
                                </Element>
                                <Icon
                                    className={cn(
                                        'max-md:w-[28px] max-md:h-[28px]',
                                        'max-md:ml-auto',
                                        'max-md:bg-[url(https://baomoi-static.bmcdn.me/web/styles/img/ic-menu-podcast.png)]',
                                        'max-md:bg-cover max-md:bg-center max-md:bg-no-repeat'
                                    )}
                                />
                            </RouterLink>
                        </Menu.List.Item>
                        {renderCategories()}
                    </Container>
                </Menu.List>
                <Element
                    className={cn(
                        'navbar-close',
                        'pt-[10px] pb-[100px]',
                        'text-center'
                    )}
                >
                    <Button
                        className={cn(
                            'text-[1.6rem] leading-[2] uppercase',
                            'h-[32px]',
                            'mx-auto px-[30px]',
                            'bg-[#e9ecef]',
                            'rounded-[0.25rem]',
                            'border border-solid border-[#dee2e6]'
                        )}
                        onClick={onClick}
                        title="Đóng"
                    >
                        Đóng
                    </Button>
                </Element>
            </>
        );
    };

    return (
        <Element
            className={twMerge(
                'navbar-menu-full',
                'hidden',
                'w-full h-[calc(100vh-90px)]',
                'bg-[#f8f9fa]',
                'text-[var(--dark)]',
                'md:bg-white',
                cn({
                    ['block h-[calc(100vh-40px)]']: isExpand,
                })
            )}
        >
            {(isPageContentDetail && !isSticky) || !showScrollbar ? (
                <>{renderMenu()}</>
            ) : (
                <Scrollbars
                    autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={200}
                >
                    {renderMenu()}
                </Scrollbars>
            )}
        </Element>
    );
}

export default memo(NavbarExpand);
